import React, { useEffect, useState, useRef } from 'react';
import './UserProfileDetails.css';
import axios from "../../../axiosInstance.js";
import { Button } from '@mui/material';
import { motion } from "framer-motion";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useLocation } from 'react-router-dom';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessIcon from "@mui/icons-material/Business";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import { FaEnvelope, FaMobile } from "react-icons/fa";

import img1 from '../../../Assets/profile/img1.png'
import pedit from '../../../Assets/profile/p-edit.svg'
import img2 from '../../../Assets/profile/img2.png'
import img3 from '../../../Assets/profile/img3.png'
import rightArrowIcon from '../../../Assets/navbar/right-arrow.svg'
import icon1 from '../../../Assets/profile/icon1.svg'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomInput from './CustomInput';
import { ArrowLeft } from 'lucide-react';
import BottomNavigationCustomer from '../CustomerHome/BottomNavigatonCustomer';
import { useModal } from '../../../context/ModalContext';
import { useWebSocket } from '../../../context/WebSocketContext';


const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
};

const UserProfileDetails = () => {

    const navigate = useNavigate()
    const { disconnectWebSocket } = useWebSocket(); // ✅ use it here
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [alertInfo, setAlertInfo] = useState(null);
    const [comingData, setComingData] = useState([]);
    const { state } = useLocation();
    //console.log('state', state)
    //console.log('comingdata', comingData)
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoadingStates, setIsLoadingStates] = useState(true);
    const [isLoadingCities, setIsLoadingCities] = useState(true);
    const { openModal, modalData, closeModal } = useModal();




    useEffect(() => {
        if (comingData) {

            console.log('here is coming data: =================')
            console.log(comingData)

            setFormData(prevFormData => ({
                ...prevFormData,

                driverName: comingData.driverName || "",
                driverNumber: comingData.driverNumber || "",
                driverEmail: comingData.driverEmail || "",
                customerDriverCode: comingData.customerDriverCode || "",
                vendorDriverCode: comingData.vendorDriverCode || "",
                CustomerCode: comingData.CustomerCode || "",
                CustomerName: comingData.CustomerName || "",
                CustomerType: comingData.CustomerType || "",
                address: comingData.address || "",
                district: comingData.district || "",
                pincode: comingData.pincode || "",
                CustomerPhone: comingData.CustomerPhone || "",
                email: comingData.email || "",
                contactPerson: comingData.contactPerson || "",
                state: comingData.state || "",
                panNo: comingData.panNo || "",
                panCard: comingData.panCard || "",
                adharNo: comingData.adharNo || "",
                adharCard: comingData.adharCard || "",
                agreement: comingData.agreement || "",
                fleetSize: comingData.fleetSize || "",
                plan: comingData.plan || "",
                vehicleNo: comingData.vehicleNo || "",
                chassisNo: comingData.chassisNo || "",
                engineNo: comingData.engineNo || "",
                make: comingData.make || "",
                model: comingData.model || "",
                year: comingData.year || "",
                type: comingData.type || "",
                application: comingData.application || "",
                GVW: comingData.GVW || "",
                ULW: comingData.ULW || "",
                InsuranceName: comingData.InsuranceName || "",
                GSTNo: comingData.GSTNo || "",
                GST: comingData.GST || "",
                businessRegistration: comingData.businessRegistration || "",
                longitude: comingData.longitude !== null ? comingData.longitude : "",
                latitude: comingData.latitude !== null ? comingData.latitude : "",
                id: comingData.id,
                choosenPlan: comingData.choosenPlan,
                vendorPhone: comingData.vendorPhone || "",
                vendorType: comingData.vendorType || "",

                vendorName: comingData.vendorName || "",
                CustomerName: comingData.CustomerName || "",
                companyName: comingData.companyName || "",


                vehicleNo: comingData.vehicleNo || '',
                chassisNo: comingData.chassisNo || '',
                engineNo: comingData.engineNo || '',
                make: comingData.make || '',
                model: comingData.model || '',
                type: comingData.type || '',
                application: comingData.application || '',
                InsuranceName: comingData.InsuranceName || '',
                GVW: comingData.GVW || '',
                ULW: comingData.ULW || '',
                DLCard: comingData.DLCard || '',
                DLNo: comingData.DLNo || '',
                year: comingData.year || '',

                bankName: comingData.bankName || '',
                bankAccount: comingData.bankAccount || '',
                ifscCode: comingData.ifscCode || '',
                branchName: comingData.branchName || '',
                cancelledCheque: comingData.cancelledCheque || '',
                profileImage: comingData.profileImage || ''


            }));

            // console.log('form data');
            // console.log(formData);
        }
    }, [comingData]);

    const [formData, setFormData] = useState({

        customerDriverCode: "",
        vendorDriverCode: "",
        CustomerName: "",
        contactPerson: "",
        vendorPhone: "",
        email: '',
        CustomerPhone: '',
        plan: '',
        vehicles: '',
        CustomerType: '',
        choosenPlan: "",
        vendorType: '',

        panNo: '',
        GSTNo: '',
        adharNo: '',
        adharCard: '',
        panCard: '',
        GST: '',
        businessRegistration: '',
        firstView: true,

        vendorName: '',
        CustomerName: '',
        driverName: "",
        driverNumber: "",
        driverEmail: "",
        vehicleNo: '',
        chassisNo: '',
        engineNo: '',
        make: '',
        model: '',
        type: '',
        application: '',
        InsuranceName: '',
        GVW: '',
        ULW: '',
        DLCard: '',
        DLNo: '',
        year: '',

        bankName: '',
        bankAccount: '',
        ifscCode: '',
        branchName: '',
        cancelledCheque: ''


    });

    //console.log('formdata123', formData)
    useEffect(() => {
        if(userId && token) {
            getDataById();
        }
    }, [userId, token])

    const getDataById = async (id) => {

        let response;
        if (userId?.startsWith("CUD-")) response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getDriverInfo/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (userId?.startsWith("CC-")) response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getCustomerById/${userId}/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (userId?.startsWith("VC-")) response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendor/${userId}/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (userId?.startsWith("VED-")) response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorDriverInfo/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });


        //console.log("daa", response.data.data)
        // console.log("response123", response.data.data[0]);
        setComingData(response.data?.data[0])

    }

    const showSuccessToast = (e) => {
        toast.success(e);
    };

    const showErrorToast = (e) => {
        toast.error(e);
    };

    const [isLoading, setIsLoading] = useState(false);

    const handleBack = () => {
        navigate(-1);
    }

    const [isUpdatePan, setIsUpdatePan] = useState(false)
    const [isUpdateBussinessReg, setIsUpdateBussinessReg] = useState(false)
    const [isUpdateCancelledCheque, setIsUpdateCancelledCheque] = useState(false)
    const [isBusinessRegistrationDoc, setIsBusinessRegistrationDoc] = useState(false)
    const [isUpdateAdhar, setIsUpdateAdhar] = useState(false)
    const [isUpdateGST, setIsUpdateGST] = useState(false)
    const [isUpdateDL, setIsUpdateDL] = useState(false)
    //console.log('formData.DLCard', formData.DLCard)

    const [step, setStep] = useState(1);
    const nextStep = () => setStep(step + 1);
    const prevStep = () => setStep(step - 1);

    const tabs = [
        { id: "tab1", label: "My Profile", },
        // { id: "tab2", label: "Payment", },
        // { id: "tab3", label: "Share App", },
        // { id: "tab4", label: "Upgrade Plan", },
    ];
    const [activeTab, setActiveTab] = useState("tab1");

    // console.log(activeTab);

    const [isEditable, setIsEditable] = useState(true);
    const [isPersonalDetailEditable, setIsPersonalDetailEditable] = useState(true);
    const [isVehicleDetailEditable, setIsVehicleDetailEditable] = useState(true);
    const [isCompanyDetailEditable, setIsCompanyeDetailEditable] = useState(true);

    const profileInputRef = useRef(null);
    const panInputRef = useRef(null);
    const aadharInputRef = useRef(null);

    const handlePanInputRefClick = () => {
        console.log('handlePanInputRefClick called:')

        console.log(formData)

        if (panInputRef.current) {
            panInputRef.current.click();
        }


    };

    const handleAdharInputRefClick = () => {
        if (aadharInputRef.current) {
            aadharInputRef.current.click();
        }
    };

    const [profileFile, setProfileFile] = useState(null)
    const [panFile, setPanFile] = useState(null)
    const [aadharFile, setAadharFile] = useState(null)

    const handleChange = (e) => {
        console.log('handleChange calling: ')

        console.log(formData)

        const { name, value, type, files } = e.target;

        if (type === 'file') {
            if (files[0] && files[0].size > 9097152) {
                setAlertInfo({ show: true, message: 'File size should be less than 2 MB!', severity: 'error' });
            }
            setFormData(prevState => ({
                ...prevState,
                [name]: files[0]
            }));

            readAsDataURL(e)

        }
        else if (name === 'state') {
            // loadCities(value);
            setFormData(prevState => ({ ...prevState, [name]: value }));
        }
        else setFormData({ ...formData, [name]: value });

    };


    const readAsDataURL = (e) => {
        const file = e.target.files[0];

        if (file) {

            const reader = new FileReader();
            reader.onloadend = () => {

                if (e.target.name === 'profileImage') {
                    setProfileFile(
                        reader.result // base64 data
                    );
                }

                if (e.target.name === 'panCard') {
                    setPanFile(
                        reader.result // base64 data
                    );
                }

                if (e.target.name === 'adharCard') {
                    setAadharFile(
                        reader.result // base64 data
                    );
                }
            };

            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        console.log('handleSubmit calling:');

        e.preventDefault();

        // Validations goes here

        // panNo is mandatory
        if (formData.panNo === undefined || formData.panNo.trim() === "" || formData.panNo.startsWith("No Pan No")) {

            // setErrorInputName('panNo');
            // openModal({
            //     title: 'Error',
            //     body: 'PAN number is mandatory',
            //     iconType: 'error',
            //     autoClose: true,
            // });
            // return;
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.panNo.trim().toUpperCase())) {
            // setErrorInputName('panNo');
            openModal({
                title: 'Error',
                body: 'Invalid PAN number format.',
                iconType: 'error',
                autoClose: true,
            });
            return;
        }

        console.log(formData)

        setIsLoading(true)

        const formDataObj = new FormData();
        for (const key in formData) {
            if (formData[key] !== undefined && formData[key] !== null && formData[key] !== "") {


                if (formData[key] instanceof File) {
                    // console.log(`Key: ${key}, Value:`, formData[key]);
                    formDataObj.append(key, formData[key], formData[key].name);
                } else {
                    formDataObj.append(key, formData[key]);
                }
            }
        }
        let urlPart = ''
        if (userId?.startsWith("CC-")) urlPart = 'customerUpdate';
        if (userId?.startsWith("CUD-")) urlPart = 'updateCustomerDriver';
        if (userId?.startsWith("VC-")) urlPart = 'venderUpdate';
        if (userId?.startsWith("VED-")) urlPart = 'updateDriverInfoVendor';

        // console.log('urlPart is: ', urlPart);

        //console.log("formDataObj", formDataObj)

        // return

        try {


            const response = await axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/${urlPart}/${userId}/${userId}`,
                data: formDataObj,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            console.log("response", response);

            // return

            if (response.data.status === true) {
                showSuccessToast('Information updated successfully!')
                // setTimeout(() => {
                //     navigate(-1)
                // }, 2000);
                await getDataById();

            } else if (response.data.status === 400) {
                showErrorToast('Already assigned Number!')
            }
        } catch (error) {
            console.error("Error:", error);

            if (error.response) {
                // Server responded with a status other than 2xx
                if (error.response.status === 404) {
                    showErrorToast('Resource not found!')
                } else if (error.response.status === 400) {
                    showErrorToast('Already assigned Number!')
                } else {
                    showErrorToast(`Unexpected error: ${error.response.status}`)
                }
            } else if (error.request) {
                // No response was received               
                showErrorToast('No response from the server. Please try again!')
            } else {
                showErrorToast('An error occurred while making the request!')
            }
        }
        finally {
            setIsLoading(false)
        }

    };

    const handleProfileInputRefClick = () => {
        console.log('handleProfileInputRefClick called:')

        console.log('formdata')
        console.log(formData)

        if (profileInputRef.current) {
            profileInputRef.current.click();
        }

    };

    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleLogout = async () => {
        const gpsLocation = localStorage.getItem('gps_location');


        const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/logout/${userId}`, { userId }, {
            headers: { 'Authorization': `Bearer ${token}` }
        });


        disconnectWebSocket();

        localStorage.clear();
        sessionStorage.clear();


        if (gpsLocation) {
            localStorage.setItem('gps_location', gpsLocation);
        }

        // navigate('/LoginPage');
        window.location.href = "/LoginPage";
    };



    return (
        <div className="user-form-container">

            <div className='flex'>
                {state?.frompage === 'craneuserprofile' && (
                    <div style={{ display: "flex", marginRight: '10px', marginBottom: '10px', marginTop: '15px', position: 'fixed', background: '#b2b2b2', padding: '5px 3px 5px 0px', marginLeft: '20px', borderRadius: '30px' }}>
                        <Button startIcon={<ArrowBackIcon />} style={{ background: "none", color: "black" }} onClick={handleBack} />
                    </div>
                )}
            </div>

            <ConfirmationModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                handleSubmit={handleLogout}
            />

            {/* CC block */}
            {userId?.startsWith("CC-") && (
                <>
                    <div className='bg-[#EFF9FD] md:px-[100px] pt-[1rem] px-[20px]'>
                        <div onClick={() => navigate(-1)} className='top-1 left-1'>
                            <ArrowLeft />
                        </div>
                        <div className="flex gap-[25px] items-center">
                            <div className='relative'>
                                {/* <img className='img-fluid' style={{ height: "250px", width: "250px", cursor: "pointer", borderRadius: "50%", }} src={profileFile || img1} */}
                                <img
                                    // hidden={formData.profileImage === ""}
                                    className="h-20 w-20 object-cover rounded-full cursor-pointer"
                                    src={profileFile || formData.profileImage}
                                    alt=""
                                    onClick={handleProfileInputRefClick}
                                />


                                <input
                                    hidden
                                    ref={profileInputRef}
                                    style={{ fontSize: '0.5rem' }}
                                    type="file"
                                    name="profileImage"
                                    onChange={handleChange}
                                    accept="image/*"
                                    className="form-control"
                                    required
                                />

                                <img onClick={handleProfileInputRefClick} src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/p-edit.svg' style={{ height: "2rem", width: "2rem" }} className='absolute right-[19px] bottom-0' alt="" />
                            </div>
                            <div >
                                <h6 className="m-0 font-satoshi font-[700] text-[26px] text-[#0A0119]">{formData.CustomerName}</h6>
                                <p className="m-0 font-satoshi font-[400] text-[13px] text-[#0A0119] pt-[5px]">{formData.email}</p>
                            </div>
                        </div>
                    </div>

                    <div className='md:px-[100px] px-[20px] md:py-[56px] py-[30px]'>
                        <div className="flex pb-[40px]">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`py-[10px] px-[13px] text-[20px] font-satoshi transition-all duration-300 border-b-[5px]
                              ${activeTab === tab.id
                                            ? "font-[700] border-[#21A6E9] text-[#21A6E9]"
                                            : "text-[#191250] font-[700] border-transparent"
                                        }`}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>

                        <div className="flex flex-col gap-[20px]" >

                            {/* Company details */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Company Detail</h6>
                                    <button hidden onClick={() => setIsCompanyeDetailEditable(!isCompanyDetailEditable)}>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Company Name</p>

                                        <CustomInput
                                            isEditable={isCompanyDetailEditable}
                                            value={formData.CustomerName}
                                            placeholder='Enter name'
                                            onChange={(e) =>
                                                setFormData({ ...formData, CustomerName: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Contact No.</p>

                                        <CustomInput
                                            isEditable={isCompanyDetailEditable}
                                            value={formData.CustomerPhone}
                                            placeholder='Enter number'
                                            onChange={(e) =>
                                                setFormData({ ...formData, CustomerPhone: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Plan</p>

                                        <CustomInput
                                            isEditable={isCompanyDetailEditable}
                                            value={formData.choosenPlan}
                                            placeholder='Enter plan'
                                            onChange={(e) =>
                                                setFormData({ ...formData, choosenPlan: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Customer Type</p>

                                        <CustomInput
                                            isEditable={isCompanyDetailEditable}
                                            value={formData.CustomerType}
                                            placeholder='Enter type'
                                            onChange={(e) =>
                                                setFormData({ ...formData, CustomerType: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                </div>
                            </div>

                            {/* Company address */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Company Address</h6>
                                    <button hidden onClick={() => setIsEditable(!isEditable)}>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Address</p>
                                        {/* <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">Rajasthan</h6> */}

                                        <CustomInput
                                            isEditable={isEditable}
                                            value={formData.address}
                                            placeholder='Enter address'
                                            onChange={(e) =>
                                                setFormData({ ...formData, address: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">City</p>
                                        {/* <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">Mumbai</h6> */}

                                        <CustomInput
                                            isEditable={isEditable}
                                            value={formData.city}
                                            placeholder='Enter city'
                                            onChange={(e) =>
                                                setFormData({ ...formData, city: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                </div>
                            </div>

                            {/* Personal details */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Personal Details</h6>
                                    <button hidden onClick={() => setIsPersonalDetailEditable(!isPersonalDetailEditable)}>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Name</p>

                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000] truncate">{formData.CustomerName}</h6>
                                        {/* <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.CustomerName}
                                            placeholder='Enter name'
                                            onChange={(e) =>
                                                setFormData({ ...formData, CustomerName: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput> */}

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Type</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.CustomerType}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Contact No.</p>

                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000] truncate">{formData.CustomerPhone}</h6>

                                        {/* <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.CustomerPhone}
                                            placeholder='Enter number'
                                            onChange={(e) =>
                                                setFormData({ ...formData, CustomerPhone: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput> */}

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Email</p>

                                        <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.email}
                                            placeholder='Enter email'
                                            onChange={(e) =>
                                                setFormData({ ...formData, email: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    {/* <div className="md:grid hidden ">
                                    </div> */}

                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">PAN No.</p>

                                        <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.panNo}
                                            placeholder='Enter PAN number'
                                            onChange={(e) =>
                                                setFormData({ ...formData, panNo: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>

                                    {/* <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Aadhar Card</p>
                                        <img src={formData.adharCard} alt="" />
                                    </div> */}



                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px] cursor-pointer"
                                    // onClick={handlePanInputRefClick}
                                    >
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Pan Card</p>

                                        <img hidden={formData.panCard === "" || formData.panCard === "Pan Value"} className='w-full h-[6rem] rounded-xl object-cover' src={panFile || formData.panCard} alt=""
                                            onClick={handlePanInputRefClick} />

                                        <input
                                            hidden={!(formData.panCard === "" || formData.panCard === "Pan Value")}
                                            ref={panInputRef}
                                            style={{ fontSize: '0.5rem' }}
                                            type="file"
                                            name="panCard"
                                            onChange={handleChange}
                                            accept="image/*"
                                            className="form-control"
                                            required
                                        />
                                    </div>

                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] 
                                    items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px] cursor-pointer"
                                    // onClick={handleAdharInputRefClick}
                                    >
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Aadhar Card</p>

                                        <img hidden={formData.adharCard === "" || formData.adharCard === "Adhar Value"} className='w-full h-[6rem] rounded-xl object-cover' src={aadharFile || formData.adharCard} alt=""
                                            onClick={handleAdharInputRefClick} />

                                        <input
                                            hidden={!(formData.adharCard === "" || formData.adharCard === "Adhar Value")}
                                            ref={aadharInputRef}
                                            style={{ fontSize: '0.5rem' }}
                                            type="file"
                                            name="adharCard"
                                            onChange={handleChange}
                                            accept="image/*"
                                            className="form-control"
                                            required
                                        />
                                    </div>

                                </div>
                            </div>

                        </div>

                        {/* Update details */}
                        <div className="grid md:grid-cols-2 grid-cols-2 pt-[52px] items-center gap-[18px] mb-[5rem]">
                            <div
                                onClick={handleSubmit}
                                className="bg-[#21A6E9] flex items-center justify-center py-[1rem] rounded-full px-4 w-full cursor-pointer"
                            >
                                <button className="text-white font-satoshi text-[13px] flex items-center gap-2">
                                    {isLoading && (
                                        <span
                                            className="spinner-border spinner-border-sm me-1"></span>
                                    )}
                                    Update Details
                                </button>
                            </div>

                            {/* Logout Button */}
                            <div
                                onClick={() => setIsModalOpen(true)}
                                className="bg-red-500 flex items-center justify-center py-[1rem] rounded-full px-4 w-full cursor-pointer"
                            >
                                <button className="text-white font-satoshi text-[13px]">
                                    Logout
                                </button>
                            </div>
                        </div>

                    </div>
                    <BottomNavigationCustomer />
                </>
            )}

            {/* CUD block */}
            {userId?.startsWith("CUD-") && (
                <>
                    <div className='bg-[#EFF9FD] md:px-[100px] pt-[1rem] px-[20px]'>
                        <div onClick={() => navigate(-1)} className='top-1 left-1'>
                            <ArrowLeft />
                        </div>
                        <div className="flex gap-[25px] items-center">
                            <div className='relative'>
                                {/* <img className='img-fluid' style={{ height: "250px", width: "250px", cursor: "pointer", borderRadius: "50%", }} src={profileFile || img1} */}
                                <img
                                    hidden={formData.profileImage === ""}
                                    className="h-20 w-20 object-cover rounded-full cursor-pointer"
                                    src={profileFile || formData.profileImage}
                                    alt=""
                                    onClick={handleProfileInputRefClick}
                                />


                                <input
                                    hidden
                                    ref={profileInputRef}
                                    style={{ fontSize: '0.5rem' }}
                                    type="file"
                                    name="profileImage"
                                    onChange={handleChange}
                                    accept="image/*"
                                    className="form-control"
                                    required
                                />

                                <img src={pedit} style={{ height: "2rem", width: "2rem" }} className='absolute right-[19px] bottom-0' alt="" />
                            </div>
                            <div >
                                <h6 className="m-0 font-satoshi font-[700] text-[36px] text-[#0A0119]">{formData.CustomerName}</h6>
                                <p className="m-0 font-satoshi font-[400] text-[13px] text-[#0A0119] pt-[5px]">{formData.email}</p>
                            </div>
                        </div>
                    </div>

                    <div className='md:px-[100px] px-[20px] md:py-[56px] py-[30px]'>
                        <div className="flex pb-[40px]">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`py-[10px] px-[13px] text-[20px] font-satoshi transition-all duration-300 border-b-[5px]
                              ${activeTab === tab.id
                                            ? "font-[700] border-[#21A6E9] text-[#21A6E9]"
                                            : "text-[#191250] font-[700] border-transparent"
                                        }`}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>

                        <div className="flex flex-col gap-[20px]" >

                            {/* Vehicle details */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Vehicle Details</h6>
                                    <button>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Vehicle No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.vehicleNo || 'N/A'}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Chassis No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.chassisNo}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Engine No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.engineNo}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Make</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.make}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Model</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.model}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Year</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.year}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Type</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.type}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Application No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.application}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Insurance</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.InsuranceName}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">GVW</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.GVW}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">ULW</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.ULW}</h6>
                                    </div>

                                    {/* <div className="md:grid hidden ">
                                    </div> */}

                                </div>
                            </div>

                            {/* Personal details */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Personal Details</h6>
                                    <button>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Customer Name</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.CustomerName}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Driver Name</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.driverName}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Contact No.</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.driverNumber}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Email</p>
                                        {/* <h6 style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}} className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.driverEmail}</h6> */}
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000] truncate max-w-[200px]">{formData.driverEmail}</h6>

                                    </div>
                                    {/* <div className="md:grid hidden ">
                                    </div> */}
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Pan</p>
                                        <img src={formData.panCard} alt="" />

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Aadhar Card</p>
                                        <img src={formData.adharCard} alt="" />
                                    </div>
                                </div>
                            </div>



                        </div>

                        {/* Update details */}
                        <div className="grid md:grid-cols-2 grid-cols-2 pt-[52px] items-center gap-[18px] mb-[5rem]">
                            <div
                                onClick={handleSubmit}
                                className="bg-[#21A6E9] flex items-center justify-center py-[1rem] rounded-full px-4 w-full cursor-pointer"
                            >
                                <button className="text-white font-satoshi text-[13px] flex items-center gap-2">
                                    {isLoading && (
                                        <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
                                    )}
                                    Update Details
                                </button>
                            </div>

                            {/* Logout Button */}
                            <div
                                onClick={() => setIsModalOpen(true)}
                                className="bg-red-500 flex items-center justify-center py-[1rem] rounded-full px-4 w-full cursor-pointer"
                            >
                                <button className="text-white font-satoshi text-[13px]">
                                    Logout
                                </button>
                            </div>
                        </div>

                    </div>
                </>
            )}

            {/* VC block */}    {  /*   has error with cusomer profile image  */}
            {userId?.startsWith("VC-") && (
                <>
                    <div className='bg-[#EFF9FD] md:px-[100px] pt-[1rem] px-[20px]'>
                        <div onClick={() => navigate(-1)} className='top-1 left-1'>
                            <ArrowLeft />
                        </div>
                        <div className="flex gap-[25px] items-center">
                            <div className='relative'>
                                {/* <img className='img-fluid' style={{ height: "250px", width: "250px", cursor: "pointer", borderRadius: "50%", }} src={profileFile || img1} */}
                                <img
                                    // hidden={formData.profileImage === ""}
                                    className="h-20 w-20 object-cover rounded-full cursor-pointer"
                                    src={profileFile || formData.profileImage}
                                    alt=""
                                    onClick={handleProfileInputRefClick}
                                />


                                <input
                                    hidden
                                    ref={profileInputRef}
                                    style={{ fontSize: '0.5rem' }}
                                    type="file"
                                    name="profileImage"
                                    onChange={handleChange}
                                    accept="image/*"
                                    className="form-control"
                                    required
                                />

                                <img onClick={handleProfileInputRefClick} src={pedit} style={{ height: "2rem", width: "2rem" }} className='absolute right-[19px] bottom-0' alt="" />
                            </div>
                            <div >
                                <h6 className="m-0 font-satoshi font-[700] text-[26px] text-[#0A0119]">{formData.vendorName}</h6>
                                <p className="m-0 font-satoshi font-[400] text-[13px] text-[#0A0119] pt-[5px]">{formData.email}</p>
                            </div>
                        </div>
                    </div>

                    <div className='md:px-[100px] px-[20px] md:py-[56px] py-[30px]'>
                        <div className="flex pb-[40px]">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`py-[10px] px-[13px] text-[20px] font-satoshi transition-all duration-300 border-b-[5px]
      ${activeTab === tab.id
                                            ? "font-[700] border-[#21A6E9] text-[#21A6E9]"
                                            : "text-[#191250] font-[700] border-transparent"
                                        }`}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>

                        <div className="flex flex-col gap-[20px]" >

                            {/* Vehicle details */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Vehicle Details</h6>
                                    <button hidden>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Vehicle No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.vehicleNo || 'N/A'}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Chassis No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.chassisNo}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Engine No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.engineNo}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Make</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.make}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Model</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.model}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Year</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.year}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Type</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.type}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Application No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.application}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Insurance</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.InsuranceName}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">GVW</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.GVW}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">ULW</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.ULW}</h6>
                                    </div>

                                    {/* <div className="md:grid hidden ">
            </div> */}

                                </div>
                            </div>

                            {/* Personal details */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Personal Details</h6>
                                    <button hidden>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Vendor Name</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.vendorName}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Driver Name</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.contactPerson}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Contact No.</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.vendorPhone}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Email</p>

                                        <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.email}
                                            placeholder='Enter email'
                                            onChange={(e) =>
                                                setFormData({ ...formData, email: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    {/* <div className="md:grid hidden ">
            </div> */}
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px] cursor-pointer"
                                    // onClick={handlePanInputRefClick}
                                    >
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Pan Card</p>

                                        <img hidden={formData.panCard === "" || formData.panCard === "Pan Value"} className='w-full h-[6rem] rounded-xl object-cover' src={panFile || formData.panCard} alt=""
                                            onClick={handlePanInputRefClick} />

                                        <input
                                            hidden={!(formData.panCard === "" || formData.panCard === "Pan Value")}
                                            ref={panInputRef}
                                            style={{ fontSize: '0.5rem' }}
                                            type="file"
                                            name="panCard"
                                            onChange={handleChange}
                                            accept="image/*"
                                            className="form-control"
                                            required
                                        />
                                    </div>

                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] 
                                    items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px] cursor-pointer"
                                    // onClick={handleAdharInputRefClick}
                                    >
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Aadhar Card</p>

                                        <img hidden={formData.adharCard === "" || formData.adharCard === "Adhar Value"} className='w-full h-[6rem] rounded-xl object-cover' src={aadharFile || formData.adharCard} alt=""
                                            onClick={handleAdharInputRefClick} />

                                        <input
                                            hidden={!(formData.adharCard === "" || formData.adharCard === "Adhar Value")}
                                            ref={aadharInputRef}
                                            style={{ fontSize: '0.5rem' }}
                                            type="file"
                                            name="adharCard"
                                            onChange={handleChange}
                                            accept="image/*"
                                            className="form-control"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>



                        </div>

                        {/* Update details */}
                        <div className="grid md:grid-cols-2 grid-cols-2 pt-[52px] items-center gap-[18px] mb-[5rem]">
                            <div
                                onClick={handleSubmit}
                                className="bg-[#21A6E9] flex items-center justify-center py-[1rem] rounded-full px-4 w-full cursor-pointer"
                            >
                                <button className="text-white font-satoshi text-[13px] flex items-center gap-2">
                                    {isLoading && (
                                        <span
                                            className="spinner-border spinner-border-sm me-1"></span>
                                    )}
                                    Update Details
                                </button>
                            </div>

                            {/* Logout Button */}
                            <div
                                onClick={() => setIsModalOpen(true)}
                                className="bg-red-500 flex items-center justify-center py-[1rem] rounded-full px-4 w-full cursor-pointer"
                            >
                                <button className="text-white font-satoshi text-[13px]">
                                    Logout
                                </button>
                            </div>
                        </div>

                    </div>
                </>
            )}

            {/* VED block */}
            {userId?.startsWith("VED-") && (
                <>
                    <div className='bg-[#EFF9FD] md:px-[100px] pt-[1rem] px-[20px]'>
                        <div onClick={() => navigate(-1)} className='top-1 left-1'>
                            <ArrowLeft />
                        </div>
                        <div className="flex gap-[25px] items-center">
                            <div className='relative'>
                                {/* <img className='img-fluid' style={{ height: "250px", width: "250px", cursor: "pointer", borderRadius: "50%", }} src={profileFile || img1} */}
                                <img
                                    // hidden={formData.profileImage === ""}
                                    className="h-20 w-20 object-cover rounded-full cursor-pointer"
                                    src={profileFile || formData.profileImage}
                                    alt=""
                                    onClick={handleProfileInputRefClick}
                                />


                                <input
                                    hidden
                                    ref={profileInputRef}
                                    style={{ fontSize: '0.5rem' }}
                                    type="file"
                                    name="profileImage"
                                    onChange={handleChange}
                                    accept="image/*"
                                    className="form-control"
                                    required
                                />

                                <img onClick={handleProfileInputRefClick} src={pedit} style={{ height: "2rem", width: "2rem" }} className='absolute right-[19px] bottom-0' alt="" />
                            </div>
                            <div >
                                <h6 className="m-0 font-satoshi font-[700] text-[26px] text-[#0A0119]">{formData.vendorName}</h6>
                                <p className="m-0 font-satoshi font-[400] text-[13px] text-[#0A0119] pt-[5px]">{formData.driverEmail
                                }</p>
                            </div>
                        </div>
                    </div>

                    <div className='md:px-[100px] px-[20px] md:py-[56px] py-[30px]'>
                        <div className="flex pb-[40px]">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`py-[10px] px-[13px] text-[20px] font-satoshi transition-all duration-300 border-b-[5px]
                        ${activeTab === tab.id
                                            ? "font-[700] border-[#21A6E9] text-[#21A6E9]"
                                            : "text-[#191250] font-[700] border-transparent"
                                        }`}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>

                        <div className="flex flex-col gap-[20px]" >

                            {/* Personal details */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Personal Details</h6>
                                    <button hidden onClick={() => setIsPersonalDetailEditable(!isPersonalDetailEditable)}>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Vendor Name</p>
                                        {/* <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.CustomerName}</h6> */}
                                        <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.vendorName}
                                            placeholder='Enter name'
                                            onChange={(e) =>
                                                setFormData({ ...formData, vendorName: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Driver Name</p>
                                        {/* <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.driverName}</h6> */}

                                        <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.driverName}
                                            placeholder='Enter name'
                                            onChange={(e) =>
                                                setFormData({ ...formData, driverName: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Contact No.</p>
                                        {/* <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.driverNumber}</h6> */}

                                        <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.driverNumber}
                                            placeholder='Enter number'
                                            onChange={(e) =>
                                                setFormData({ ...formData, driverNumber: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Email</p>
                                        {/* <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.driverEmail}</h6> */}

                                        <CustomInput
                                            isEditable={isPersonalDetailEditable}
                                            value={formData.driverEmail}
                                            placeholder='Enter email'
                                            onChange={(e) =>
                                                setFormData({ ...formData, driverEmail: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>


                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px] cursor-pointer"
                                    // onClick={handlePanInputRefClick}
                                    >
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Pan Card</p>

                                        <img hidden={formData.panCard === "" || formData.panCard === "Pan Value"} className='w-full h-[6rem] rounded-xl object-cover' src={panFile || formData.panCard} alt=""
                                            onClick={handlePanInputRefClick} />

                                        <input
                                            hidden={!(formData.panCard === "" || formData.panCard === "Pan Value")}
                                            ref={panInputRef}
                                            style={{ fontSize: '0.5rem' }}
                                            type="file"
                                            name="panCard"
                                            onChange={handleChange}
                                            accept="image/*"
                                            className="form-control"
                                            required
                                        />
                                    </div>

                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] 
                                    items-center bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px] cursor-pointer"
                                    // onClick={handleAdharInputRefClick}
                                    >
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Aadhar Card</p>

                                        <img hidden={formData.adharCard === "" || formData.adharCard === "Adhar Value"} className='w-full h-[6rem] rounded-xl object-cover' src={aadharFile || formData.adharCard} alt=""
                                            onClick={handleAdharInputRefClick} />

                                        <input
                                            hidden={!(formData.adharCard === "" || formData.adharCard === "Adhar Value")}
                                            ref={aadharInputRef}
                                            style={{ fontSize: '0.5rem' }}
                                            type="file"
                                            name="adharCard"
                                            onChange={handleChange}
                                            accept="image/*"
                                            className="form-control"
                                            required
                                        />
                                    </div>


                                </div>
                            </div>

                            {/* Vehicle details */}
                            <div className="bg-[#EFF9FD] rounded-[16px] p-[30px]">
                                <div className="flex items-center justify-between pb-[33px]">
                                    <h6 className="m-0 font-satoshi font-[500] text-[24px] text-[#0A0119]">Vehicle Details</h6>
                                    <button hidden onClick={() => setIsVehicleDetailEditable(!isVehicleDetailEditable)}>
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/profile/icon1.svg' alt="" />
                                    </button>
                                </div>
                                <div className='grid md:grid-cols-2 grid-cols-1 gap-y-[12px] gap-x-[10px]'>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Vehicle No</p>
                                        {/* <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.vehicleNo || 'N/A'}</h6> */}

                                        <CustomInput
                                            isEditable={isVehicleDetailEditable}
                                            value={formData.vehicleNo}
                                            placeholder='Enter number'
                                            onChange={(e) =>
                                                setFormData({ ...formData, vehicleNo: e.target.value })
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleSubmit(e);
                                                }
                                            }}
                                        ></CustomInput>

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Chassis No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.chassisNo}</h6>

                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Engine No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.engineNo}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Make</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.make}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Model</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.model}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Year</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.year}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Type</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.type}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Application No</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.application}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">Insurance</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.InsuranceName}</h6>
                                    </div>
                                    <div className="grid grid-cols-2 border-[1px] border-[#E7E4FC] bg-[#F8FAFF] rounded-[12px] py-[10px] px-[20px]">
                                        <p className="m-0 font-satoshi font-[400] text-[14px] text-[#000000]">GVW</p>
                                        <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000]">{formData.GVW}</h6>
                                    </div>


                                    {/* <div className="md:grid hidden ">
                              </div> */}

                                </div>
                            </div>

                        </div>

                        {/* Update details */}
                        <div className="grid md:grid-cols-2 grid-cols-2 pt-[52px] items-center gap-[18px] mb-[5rem]">
                            <div
                                onClick={handleSubmit}
                                className="bg-[#21A6E9] flex items-center justify-center py-[1rem] rounded-full px-4 w-full cursor-pointer"
                            >
                                <button className="text-white font-satoshi text-[13px] flex items-center gap-2">
                                    {isLoading && (
                                        <span
                                            className="spinner-border spinner-border-sm me-1"></span>
                                    )}
                                    Update Details
                                </button>
                            </div>

                            {/* Logout Button */}
                            <div
                                onClick={() => setIsModalOpen(true)}
                                className="bg-red-500 flex items-center justify-center py-[1rem] rounded-full px-4 w-full cursor-pointer"
                            >
                                <button className="text-white font-satoshi text-[13px]">
                                    Logout
                                </button>
                            </div>
                        </div>


                    </div>
                </>
            )}




        </div>
    );
};

export default UserProfileDetails;



function ConfirmationModal({ isOpen, onClose, handleSubmit }) {
    if (!isOpen) return null;
    return (
        <div className="font-satoshi fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
                <h2 className="text-lg font-semibold mb-2"> Confirmation of Logout?</h2>
                <p className="text-gray-600 text-sm mb-6">
                    Are you sure you want to logout the app?
                </p>
                <div className="flex justify-around text-sm">
                    <button
                        className="text-gray-700 hover:underline"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="text-blue-600 hover:underline font-medium"
                        onClick={() => {
                            onClose();
                            handleSubmit();
                        }}
                    >
                        Logout
                    </button>
                </div>
            </div>
        </div>)
}